import React from 'react';
import JavascriptSets from './JavascriptSets.jsx';
import JavascriptSetsMethods from './JavascriptSetsMethods.jsx';
import JavascriptSetsLogic from './JavascriptSetsLogic.jsx';
import JavascriptSetsWeakset from './JavascriptSetsWeakset.jsx';
import JavascriptSetsReference from './JavascriptSetsReference.jsx';
import JavascriptMaps from './JavascriptMaps.jsx';
import JavascriptMapsMethods from './JavascriptMapsMethods.jsx';
import JavascriptMapsWeakmap from './JavascriptMapsWeakmap.jsx';
import JavascriptMapsReference from './JavascriptMapsReference.jsx';

export default function JsSetsMaps() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Sets & Maps</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/sets' className='underline'>JS Sets</a></li>
<li><a href='/javascript/sets/methods' className='underline'>JS Set Methods</a></li>
<li><a href='/javascript/sets/logic' className='underline'>JS Set Logic</a></li>
<li><a href='/javascript/sets/weakset' className='underline'>JS Set WeakSet</a></li>
<li><a href='/javascript/sets/reference' className='underline'>JS Set Reference</a></li>
<li><a href='/javascript/maps' className='underline'>JS Maps</a></li>
<li><a href='/javascript/maps/methods' className='underline'>JS Map Methods</a></li>
<li><a href='/javascript/maps/weakmap' className='underline'>JS Map WeakMap</a></li>
<li><a href='/javascript/maps/reference' className='underline'>JS Map Reference</a></li>
      </ul>
    </div>
  );
}
